import React, { useRef } from "react"
import { ReactSVG } from "react-svg"

import { graphql } from "gatsby"
import { KeyFigureFieldsFragment } from "../../../../../../../graphql-types"

import * as styles from "./key-figure.module.scss"

type KeyFigureProps = {
  data: KeyFigureFieldsFragment
  keyFigureAmount: number
}

const KeyFigure: React.FC<KeyFigureProps> = ({ data, keyFigureAmount }) => {
  const refContainer = useRef(null)

  const displayImg = (image, classes?): JSX.Element => {
    if (!image) return

    return image.format === "svg" ? (
      <ReactSVG className={classes} src={image.url} title={image.title} />
    ) : (
      <img src={image.url} alt={image.alt || ""} title={image.title} className={classes} />
    )
  }

  return (
    <section className={keyFigureAmount === 4 ? styles.containerSmaller : styles.container} ref={refContainer}>
      <div className={styles.keyContainer}>
        {data.symbolBeforeNumber && <p className={styles.symbol}>{data.symbolBeforeNumber}</p>}
        <p className={styles.number}>{data.number}</p>
        {data.symbolAfterNumber && <p className={styles.symbol}>&nbsp;{data.symbolAfterNumber}</p>}
        {displayImg(data.icon, styles.icon)}
      </div>
      <p className={styles.subtitle}>{data.subtitle}</p>
    </section>
  )
}

export const fragment = graphql`
  fragment KeyFigureFields on DatoCmsKeyFigure {
    __typename
    id
    number
    symbolAfterNumber
    symbolBeforeNumber
    subtitle
    icon {
      alt
      format
      title
      url
    }
  }
`

export default KeyFigure
